var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "calendar_1_",
    "data-name": "calendar (1)",
    d: "M20.174,2166.2H5.8v-2.726a.873.873,0,0,1,.873-.874h.924v1.8h1.8v-1.8H16.58v1.8h1.8v-1.8h.9a.9.9,0,0,1,.9.9Zm0,8.1a.9.9,0,0,1-.9.9H6.7a.9.9,0,0,1-.9-.9V2168H20.173v6.3Zm-16.116.685A2.044,2.044,0,0,0,5.912,2177H20.288A1.861,1.861,0,0,0,22,2174.986c0-.35-.029-11.161-.029-11.748,0-1.874-.252-2.437-3.595-2.437V2159h-1.8v1.8H9.391V2159h-1.8v1.8H5.8a1.8,1.8,0,0,0-1.8,1.8l.058,12.385Z",
    transform: "translate(-4 -2159.001)",
    fill: "#304669",
    fillRule: "evenodd",
    opacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarIcon);
export default __webpack_public_path__ + "static/media/calendar-icon.8c1470ffb60ca38680acf20d7ddaec26.svg";
export { ForwardRef as ReactComponent };